export const DATABASE_IFRAME_TITLE = 'database-frame';
